import { BellFilled } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Button } from 'antd';

export const SContainer = styled.header`
  background-color: transparent;
  margin-right: 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  height: 72px;
  margin-bottom: 24px;
`;

export const SBellFilled = styled(BellFilled)`
  font-size: 20px;
  cursor: pointer;
`;

export const SUserIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 32px;
  cursor: pointer;
  font-size: 20px;
  color: #242424;
  width: 32px;
  height: 32px;
  background: #d9d9d9;
  position: relative;
`;

export const SBurgerMenuButton = styled(Button)`
  background: transparent;
  outline: 0;
  outline-offset: 0;
  padding: 0;
  box-shadow: none;
  height: 24px;
  width: 24px;
  margin: 0 20px;
  border: 0;

  svg {
    width: 24px;
    height: 24px;
  }
`;
